module.exports = __webpack_public_path__ + "static/media/gallery_16.06ca3ae4.jpg";